import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Heading, Text, Container, Button, Flex } from "@chakra-ui/react";
import Header from "../../components/reusables/Header/Header";
import Footer from "../../components/includes/Footer/Footer";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndConditions from "./TermsAndConditions";
import RefundsCancellations from "./RefundsCancellations";

const CompanyPolicies: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"privacy" | "terms" | "refunds">(
    "privacy",
  );
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Set active tab based on current route
    if (location.pathname === "/privacy-policy") {
      setActiveTab("privacy");
    } else if (location.pathname === "/terms-and-conditions") {
      setActiveTab("terms");
    } else if (location.pathname === "/refunds-cancellations") {
      setActiveTab("refunds");
    }

    // Smooth scroll to top when route changes
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  const renderContent = () => {
    switch (activeTab) {
      case "privacy":
        return <PrivacyPolicy />;
      case "terms":
        return <TermsAndConditions />;
      case "refunds":
        return <RefundsCancellations />;
      default:
        return <PrivacyPolicy />;
    }
  };

  return (
    <Box
      bg="gray.50"
      minH="100vh"
      // py={8}
    >
      <Header />
      <Container maxW="container.xl">
        <Box bg="white" mb={6} overflow="hidden">
          <Flex bg="gray.50" borderBottom="1px" borderColor="gray.200" p={4}>
            <Button
              variant="ghost"
              onClick={() => {
                navigate("/privacy-policy");
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
              mr={2}
              fontWeight="semibold"
              color={activeTab === "privacy" ? "brand.500" : "gray.600"}
              borderBottom={
                activeTab === "privacy" ? "2px solid" : "2px solid transparent"
              }
              borderBottomColor={
                activeTab === "privacy" ? "brand.500" : "transparent"
              }
              borderRadius="0"
              pb={1}
              _hover={{
                color: "brand.500",
                bg: "transparent",
              }}
            >
              Privacy Policy
            </Button>
            <Button
              variant="ghost"
              onClick={() => {
                navigate("/terms-and-conditions");
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
              mr={2}
              fontWeight="semibold"
              color={activeTab === "terms" ? "brand.500" : "gray.600"}
              borderBottom={
                activeTab === "terms" ? "2px solid" : "2px solid transparent"
              }
              borderBottomColor={
                activeTab === "terms" ? "brand.500" : "transparent"
              }
              borderRadius="0"
              pb={1}
              _hover={{
                color: "brand.500",
                bg: "transparent",
              }}
            >
              Terms & Conditions
            </Button>
            <Button
              variant="ghost"
              onClick={() => {
                navigate("/refunds-cancellations");
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
              fontWeight="semibold"
              color={activeTab === "refunds" ? "brand.500" : "gray.600"}
              borderBottom={
                activeTab === "refunds" ? "2px solid" : "2px solid transparent"
              }
              borderBottomColor={
                activeTab === "refunds" ? "brand.500" : "transparent"
              }
              borderRadius="0"
              pb={1}
              _hover={{
                color: "brand.500",
                bg: "transparent",
              }}
            >
              Refunds & Cancellations
            </Button>
          </Flex>
        </Box>

        {/* Content Section */}
        <Box mb={2}>
          <Box bg="gray.50" minH="100vh" py={8}>
            <Container maxW="container.xl">
              {/* Content Section */}
              <Box bg="white" borderRadius="lg" shadow="xs" p={10}>
                {renderContent()}
                <Box
                  mt={4}
                  bg="blue.50"
                  p={4}
                  borderRadius="md"
                  borderLeft="4px"
                  borderLeftColor="blue.500"
                >
                  <Heading as="h4" size="sm" color="blue.800" mb={2}>
                    Contact Information
                  </Heading>
                  <Text color="blue.700" fontSize="sm">
                    For privacy queries, contact: connect@cashquin.com, +91
                    9511520346
                    <br />
                    Webtooth Techno LLP, Sector-49 Gurugram, Haryana
                  </Text>
                </Box>
              </Box>
            </Container>
          </Box>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default CompanyPolicies;
